import { answerStateMap, smallQuestionTypeEnum } from '@/views/PaperCollect/enum'
import { getUserListByIds } from '@/api/common'
import { setAnswerForSmallList, setAnswerStudentNameInMultiple } from '@/views/PaperCollect/utils'

const state = () => ({
  currentClazzId: '',
  // 作答状态：1初始化，2作答中，3作答结束
  answerState: answerStateMap.init,
  bigQuestionList: [],
  studentList: [],
  // 学生姓名映射
  studentNameMap: {}
})

const getters = {
  currentClazzId: state => state.currentClazzId,
  isAnswering: state => state.answerState === 2,
  isAnswerEnd: state => state.answerState === 3,
  bigQuestionList: state => state.bigQuestionList,
  smallQuestionList: (state, getters) => getters.bigQuestionList.map(big => big.smallList).flat(),
  studentList: state => state.studentList,
  studentNameMap: state => state.studentNameMap
}

const mutations = {
  SET_CURRENT_CLAZZ_ID(state, payload) {
    state.currentClazzId = payload
  },
  SET_ANSWER_STATE(state, payload) {
    state.answerState = payload
  },
  SET_BIG_QUESTION_LIST(state, payload) {
    state.bigQuestionList = payload
  },
  SET_STUDENT_LIST(state, payload) {
    state.studentList = payload
  },
  SET_STUDENT_NAME_MAP(state, payload) {
    state.studentNameMap = payload
  }
}

const actions = {
  setCurrentClazzId({ commit }, payload) {
    commit('SET_CURRENT_CLAZZ_ID', payload)
  },
  setAnswerState({ commit }, payload) {
    commit('SET_ANSWER_STATE', payload)
  },
  setBigQuestionList({ commit }, payload) {
    commit('SET_BIG_QUESTION_LIST', payload)
  },
  setStudentList({ commit }, payload) {
    commit('SET_STUDENT_LIST', payload)
  },
  setStudentNameMap({ commit }, payload) {
    commit('SET_STUDENT_NAME_MAP', payload)
  },
  resetData({ dispatch }) {
    dispatch('setAnswerState', answerStateMap.init)
    dispatch('setBigQuestionList', [])
    dispatch('setStudentList', [])
    dispatch('setStudentNameMap', {})
  },
  // 设置学生姓名映射表
  async setAnswerStudentNameMap({ getters, dispatch }) {
    const userIds = getters.studentList.map(item => item.id)
    const { data = [] } = await getUserListByIds({ userIds })
    const studentNameMap = {}
    data.forEach(item => {
      studentNameMap[item.id] = item.realName || item.name || '-'
    })
    dispatch('setStudentNameMap', studentNameMap)
  },
  // 设置作答和未作答学生的名字
  async setAnswerStudentName({ getters, dispatch }) {
    const bigQuestionList = getters.bigQuestionList
    for (let i = 0; i < bigQuestionList.length; i++) {
      const big = bigQuestionList[i]
      big.smallList = setAnswerForSmallList(big.smallList)
      big.smallList.forEach(small => {
        if (small.notDoneUserId.length > 0) {
          small.notDoneUserName = small.notDoneUserId.map(id => getters.studentNameMap[id]).join('，')
        }
        // 如果是多选并且设置了答案，则要找出回答正确，回答不准确和回答错误的学生
        if (small.type === smallQuestionTypeEnum.multipleChoose && small.answer) {
          // 作答的学生
          const answerUserIds = Array.from(new Set(small.optionsTypeList.map(option => option.userId).flat()))
          // 正确选项
          const correctOptionsTypeList = small.optionsTypeList.filter(item => small.answer.includes(item.id))
          console.log(answerUserIds)
          const correctUserName = []
          const wrongUserName = []
          const inaccurateUserList = []
          answerUserIds.forEach(userId => {
            const userName = getters.studentNameMap[userId]
            const answerOptions = small.optionsTypeList.filter(item => item.userId.includes(userId))
            const isCorrect = correctOptionsTypeList.every(item => item.userId.includes(userId))
            // 回答正确：选择的答案必须包含所有正确答案，并且选择答案数量与正确答案数量一致
            if (isCorrect && answerOptions.length === correctOptionsTypeList.length) {
              correctUserName.push(userName)
              return
            }
            // 回答错误
            const isWrong = correctOptionsTypeList.every(item => !item.userId.includes(userId))
            if (isWrong) {
              wrongUserName.push(userName)
              return
            }
            // 回答不准确
            inaccurateUserList.push({
              userName,
              answerOptions
            })
          })
          small.correctUserName = correctUserName
          small.wrongUserName = wrongUserName
          small.inaccurateUserList = inaccurateUserList
        }
        small.optionsTypeList.forEach(option => {
          if (option.userId.length > 0) {
            option.userName = option.userId.map(id => getters.studentNameMap[id]).join('，')
          }
        })
      })
      bigQuestionList[i] = big
    }
    dispatch('setBigQuestionList', bigQuestionList)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
